// IMPORTS
// Navigation imports
import NavbarContainer from './src/js/containers/navigation/NavbarContainer';
import AlertsNotificationContainer from './src/js/containers/navigation/AlertsNotificationContainer';
import SearchInputContainer from './src/js/containers/navigation/SearchInputContainer';
import Footer from './src/js/components/navigation/footer/Footer';
import AccountPanel from './src/js/components/navigation/account/AccountPanel';
import ConfirmPasswordModal from './src/js/components/navigation/account/confirmPassword/ConfirmPasswordModal';
import SignInModal from './src/js/components/navigation/account/signIn/SignInModal';
import RequireLogin from './src/js/containers/RequireLogin';

// Reducer imports
import sarsaparillaReducers from './src/js/reducers';
import searchCriteriaReducers from './src/js/reducers/search/searchCriteriaReducers';
import searchSuggestionsReducers from './src/js/reducers/search/searchSuggestionsReducers';

// Action imports
import * as AlertActions from './src/js/actions/navigation/alertActions';
import * as CartActions from './src/js/actions/navigation/cartActions';
import * as LoginActions from './src/js/actions/navigation/loginActions';
import * as SearchActions from './src/js/actions/navigation/searchActions';

// Store
import store from './src/store';

// Style Guide Imports
import AvailabilityTypes from './src/js/components/sharedComponents/AvailabilityTypes';
import BlockTabs from './src/js/components/sharedComponents/BlockTabs';
import Breadcrumbs from './src/js/components/sharedComponents/Breadcrumbs';
import Pagination from './src/js/components/sharedComponents/Pagination';
import CartTimer from './src/js/components/sharedComponents/CartTimer';
import ContentSwitcher from './src/js/components/sharedComponents/ContentSwitcher';
import Label from './src/js/components/sharedComponents/Label';
import Dropdown from './src/js/components/sharedComponents/dropdown/Dropdown';
import * as Icons from './src/js/components/sharedComponents/icons/Icons';
import * as BrandingIcons from './src/js/components/sharedComponents/icons/branding/BrandingIcons';
import * as CardIcons from './src/js/components/sharedComponents/icons/creditCards/CreditCardIcons';
import * as PartnerIcons from './src/js/components/sharedComponents/icons/partners/PartnerIcons';
import * as InventoryTag from './src/js/components/sharedComponents/inventoryTags/InventoryTag';
import * as InventoryTagSpan from './src/js/components/sharedComponents/inventoryTags/InventoryTagSpan';
import Loading from './src/js/components/sharedComponents/Loading';
import NavBar from './src/js/components/sharedComponents/header/Header';
import Panel from './src/js/components/sharedComponents/Panel';
import ProgressIndicator from './src/js/components/sharedComponents/ProgressIndicator';
import SubNav from './src/js/components/sharedComponents/header/Subheader';
import Tabs from './src/js/components/sharedComponents/Tabs';
import Slider from './src/js/components/sharedComponents/Slider';
import Gallery from './src/js/components/sharedComponents/Gallery';
import MediaGallery from './src/js/components/sharedComponents/MediaGallery';
import StarRating from './src/js/components/sharedComponents/StarRating';
import ImageUnavailable from './src/js/components/sharedComponents/ImageUnavailable';
import InventoryImage from './src/js/components/sharedComponents/InventoryImage';
import HeroImage from './src/js/components/sharedComponents/HeroImage';
import HeroImageCombined from './src/js/components/sharedComponents/HeroImageCombined';
import HeroImageSectionFront from './src/js/components/sharedComponents/HeroImageSectionFront';
import SvgLoading from './src/js/components/sharedComponents/SvgLoading';
import HeroImageUnavailable from './src/js/components/sharedComponents/HeroImageUnavailable';
import HeroImageLowQuality from './src/js/components/sharedComponents/HeroImageLowQuality';
import DateRangePicker from './src/js/components/sharedComponents/datePicker/DateRangePicker';
import DayPickerRangeController from './src/js/components/sharedComponents/datePicker/DayPickerRangeController';
import SingleDatePicker from './src/js/components/sharedComponents/datePicker/SingleDatePicker';
import DayPickerSingleDateController from './src/js/components/sharedComponents/datePicker/DayPickerSingleDateController';
import EditableWrapper from './src/js/components/sharedComponents/editableWrapper/EditableWrapper';
import DisplayTemplate from './src/js/components/sharedComponents/editableWrapper/DisplayTemplate';
import EditTemplate from './src/js/components/sharedComponents/editableWrapper/EditTemplate';
import GuestCounter from './src/js/components/sharedComponents/guestCounter/GuestCounter';
import PopupContent from './src/js/components/sharedComponents/map/PopupContent';
import CampsiteOrderItem from './src/js/components/sharedComponents/internalAccounts/orderSummary/CampsiteOrderItem';
import TourOrderItem from './src/js/components/sharedComponents/internalAccounts/orderSummary/TourOrderItem';
import OrderPriceItem from './src/js/components/sharedComponents/internalAccounts/orderSummary/OrderPriceItem';
import ModifiedOrderItem from './src/js/components/sharedComponents/internalAccounts/orderSummary/ModifiedOrderItem';
import ExistingOrderItem from './src/js/components/sharedComponents/internalAccounts/orderSummary/ExistingOrderItem';
import PhotoManagementComponent from './src/js/components/sharedComponents/photoManagement/PhotoManagementComponent';
import Modal from './src/js/components/sharedComponents/Modal';
import NotFoundPage from './src/js/components/navigation/NotFoundPage';
import ToolTip from './src/js/components/sharedComponents/ToolTip';
import AvailabilityCell from './src/js/components/sharedComponents/tables/AvailabilityCell';
import SortableTableColumnHeader from './src/js/components/sharedComponents/tables/SortableTableColumnHeader';
import PasswordStrengthIndicator from './src/js/components/sharedComponents/PasswordStrengthIndicator';
import ValidationModal from './src/js/components/sharedComponents/ValidationModal';
import HelmetWrapper from './src/js/components/sharedComponents/HelmetWrapper';
import SingleClickButton from './src/js/components/sharedComponents/SingleClickButton';
import StickyBottomHelper from './src/js/components/sharedComponents/StickyBottomHelper';
import Announcement from './src/js/components/sharedComponents/Announcement';
import OrderConfirmationPage from './src/js/components/sharedComponents/orderDetails/OrderConfirmationPage';

// Helpers
import * as AlertLevelsHelper from './src/js/helpers/alertLevelsHelper';
import * as CartHelper from './src/js/helpers/cartHelper';
import * as DateHelper from './src/js/helpers/dateHelper';
import * as LoggingHelper from './src/js/helpers/loggingHelper';
import * as MapHelper from './src/js/helpers/mapHelper';
import * as ScrollToHelper from './src/js/helpers/scrollToHelper';
import * as SecurityHelper from './src/js/helpers/securityHelper';
import * as StateHelper from './src/js/helpers/stateHelper';
import * as StringHelper from './src/js/helpers/stringHelper';
import * as URLHelper from './src/js/helpers/urlHelper';

// UI Shared Components
import Carousel from './src/js/components/sharedComponents/Carousel';
import AccountSubmenu from './src/js/components/navigation/account/AccountSubmenu';
import SubnavCalendar from './src/js/components/navigation/SubnavCalendar';
import BackToTop from './src/js/components/sharedComponents/BackToTop';
import Breadcrumb from './src/js/components/sharedComponents/Breadcrumb';
import ErrorReporting from './src/js/components/sharedComponents/ErrorReporting';
import SuggestPass from './src/js/components/sharedComponents/SuggestPass';
import NeedToKnow from './src/js/components/sharedComponents/NeedToKnow';
import FavoriteHeart from './src/js/components/sharedComponents/FavoriteHeart';
import { ExternalLink } from "./src/js/components/sharedComponents/Link";
import ExternalVerifyContactInfo from "./src/js/components/sharedComponents/verifycontact/ExternalVerifyContactInfo";
import InternalVerifyContactInfo from "./src/js/components/sharedComponents/verifycontact/InternalVerifyContactInfo";
import DisplayHtmlContent from "./src/js/components/sharedComponents/DisplayHtmlContent";

// Maps
import * as mapUtils from './src/js/components/sharedComponents/map/mapUtils';
import MapLayerControl from './src/js/components/sharedComponents/map/MapLayerControl';
import MapFullscreenControl from './src/js/components/sharedComponents/map/MapFullscreenControl';
import MapSearchOnMoveControl from './src/js/components/sharedComponents/map/MapSearchOnMoveControl';
import AreaMap from './src/js/components/sharedComponents/map/AreaMap';
import MapBox from './src/js/components/sharedComponents/map/Mapbox';
import GMap from './src/js/components/sharedComponents/map/GMap';

// Validations
import CompareValidation from './src/js/components/validation/CompareValidation';
import CustomValidation from './src/js/components/validation/CustomValidation';
import EmailValidation from './src/js/components/validation/EmailValidation';
import LatitudeValidation from './src/js/components/validation/LatitudeValidation';
import LongitudeValidation from './src/js/components/validation/LongitudeValidation';
import PassValidation from './src/js/components/validation/PassValidation';
import PhoneValidation from './src/js/components/validation/PhoneValidation';
import RangeValidation from './src/js/components/validation/RangeValidation';
import RegexValidation from './src/js/components/validation/RegexValidation';
import RequiredValidation from './src/js/components/validation/RequiredValidation';
import ValidationMessage from './src/js/components/validation/ValidationMessage';
import Notice from './src/js/components/notifications/Notice';
import NotificationsWrapper from './src/js/components/notifications/NotificationsWrapper';
import NotificationToast from './src/js/components/notifications/notificationTypes/NotificationToast';

// EXPORTS

import axios from 'axios';

axios.defaults.headers.common.Pragma = 'no-cache';
axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';

export { NavbarContainer };
export { AlertsNotificationContainer };
export { SearchInputContainer };
export { Footer };
export { AccountPanel };
export { ConfirmPasswordModal };
export { SignInModal };
export { RequireLogin };


export { sarsaparillaReducers };
export { searchCriteriaReducers };
export { searchSuggestionsReducers };

export { store };
export { StickyBottomHelper };
export { AlertActions };
export { AvailabilityTypes };
export { CartActions };
export { LoginActions };
export { SearchActions };

export { BlockTabs };
export { Breadcrumbs };
export { Pagination };
export { CartTimer };
export { ContentSwitcher };
export { Label };
export { Dropdown };
export { Icons };
export { BrandingIcons };
export { CardIcons };
export { PartnerIcons };
export { InventoryTag };
export { InventoryTagSpan };
export { Loading };
export { NavBar };
export { Panel };
export { ProgressIndicator };
export { SubNav };
export { Tabs };
export { Slider };
export { Gallery };
export { MediaGallery };
export { StarRating };
export { ImageUnavailable };
export { InventoryImage };
export { HeroImage };
export { HeroImageCombined };
export { SvgLoading };
export { HeroImageUnavailable };
export { HeroImageLowQuality };
export { HeroImageSectionFront };
export { DateRangePicker };
export { DayPickerRangeController };
export { SingleDatePicker };
export { DayPickerSingleDateController };
export { EditableWrapper };
export { DisplayTemplate };
export { EditTemplate };
export { GuestCounter };
export { PopupContent };
export { CampsiteOrderItem };
export { TourOrderItem };
export { OrderPriceItem };
export { ModifiedOrderItem };
export { ExistingOrderItem };
export { PhotoManagementComponent };
export { Modal };
export { ToolTip };
export { AvailabilityCell };
export { SortableTableColumnHeader };
export { PasswordStrengthIndicator };
export { ValidationModal };
export { HelmetWrapper };
export { SingleClickButton };
export { Announcement };
export { DisplayHtmlContent };
export { OrderConfirmationPage };

export { AlertLevelsHelper };
export { CartHelper };
export { DateHelper };
export { LoggingHelper };
export { MapHelper };
export { ScrollToHelper };
export { SecurityHelper };
export { StateHelper };
export { StringHelper };
export { URLHelper };
export { NotFoundPage };

export { Carousel };
export { AccountSubmenu };
export { SubnavCalendar };
export { BackToTop };
export { Breadcrumb };
export { ErrorReporting };
export { SuggestPass };
export { NeedToKnow };
export { FavoriteHeart };
export { ExternalLink };
export { ExternalVerifyContactInfo }
export { InternalVerifyContactInfo }

export { mapUtils };
export { MapLayerControl };
export { MapFullscreenControl };
export { MapSearchOnMoveControl };
export { AreaMap };
export { MapBox };
export { GMap };

export { CompareValidation };
export { CustomValidation };
export { EmailValidation };
export { LatitudeValidation };
export { LongitudeValidation };
export { PassValidation };
export { PhoneValidation };
export { RangeValidation };
export { RegexValidation };
export { RequiredValidation };
export { ValidationMessage };
export { Notice };
export { NotificationsWrapper };
export { NotificationToast };

export {
    Button,
    Cell,
    Divider,
    LeftRail,
    PageBody,
    PageLayout,
    PageSection,
    RightRail,
    Row,
    Spinner
} from './src/js/components/sharedComponents/layout';
